import React from 'react'
import {
  Op,
  RawValue,
  DollarValue,
  AddedPercentage,
  PercentageOf,
  Formula,
  Result,
  ParseError
} from '../UI/FormulaTokens'


// Support function

const processToken = (token, index, deleteCallback) => {
  if (token.value && !token.formatted_value) {
    return (
      <RawValue
        key={index}
        value={token.value}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
  if (token.op) {
    return (
      <Op
        key={index}
        value={token.op}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
  if (token.formula) {
    return (
      <Formula
        key={index}
        name={token.formula}
        formulaType={token.type}
        value={token.formatted_value}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
  if (token.reference_value && token.value_type === 'dollar_value') {
    return (
      <DollarValue
        key={index}
        name={token.reference_value}
        value={token.formatted_value}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
  if (token.reference_value && token.value_type === 'added_percentage') {
    return (
      <AddedPercentage
        key={index}
        name={token.reference_value}
        value={token.formatted_value}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
  if (token.reference_value && token.value_type === 'percentage_of') {
    return (
      <PercentageOf
        key={index}
        name={token.reference_value}
        value={token.formatted_value}
        onRequestDelete={(
          deleteCallback ?
          () => deleteCallback(index) :
          null
        )}
      />
    )
  }
}

/*
Props:
- parsedFormula: the parsed formula to be displayed
- includeResult: Boolean(false) - specifies if the result should be included
- onTokenDelete: function(tokenIndex) - called when the delete icon on a token
  is clicked. The delete icon will only show up if this callback is included
- style: CSS styling
*/
const ParsedFormulaDisplay = (props) => (
  <div style={props.style}>
    {
      props.parsedFormula.attributes &&
      props.parsedFormula.attributes.parsedFormula &&
      props.parsedFormula.attributes.parsedFormula.map((token, index) => {
        return processToken(token, index, props.onTokenDelete)
      })
    }
    {
      props.includeResult &&
      props.parsedFormula.attributes &&
      props.parsedFormula.attributes.formattedResult &&
      <Result key={-1} value={props.parsedFormula.attributes.formattedResult} />
    }
    {
      props.error &&
      <ParseError key={-2} value={props.error} />
    }
  </div>
)

export default ParsedFormulaDisplay



// WEBPACK FOOTER //
// ./src/components/Formulas/ParsedFormulaDisplay.jsx